import {Environment} from "appRoot/app.constants";
import {BookingStatusNames, BookingStatusTypes} from 'app/bookingStatusTypes';
import {BookingMethods, IBackChannelBooking } from 'app/app.types';
import BookingLookupService from 'external-services/booking-lookup-service'
import { ToastType, IToastAction, BookingType, IToastActionClean } from "shared-types/index"
import moment from 'moment';
import AdminService from 'external-services/diary-admin-service/admin.service';
import DateUtilsService from 'external-services/date-utils-service';
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";

const NS = 'BackChannelService';
export const WIDGET_CANCELLATION_SIGNAL: string = 'WidgetCancellationSignal';
class BackChannelService {
  private $rootScope:any;
  private ToastActions: IToastActionClean;
  private backChannelServiceActive: boolean = false;
  private timeOutId: NodeJS.Timeout = null;
  private initRequested = false;

  setup($rootScope: any, ToastActions: IToastActionClean) {
    this.$rootScope = $rootScope;
    this.ToastActions = ToastActions;

    // call init, if setup called after init
    if (this.initRequested) {
      this.initRequested = false;
      this.init();
    }
  }
  public init(): void {

    // delay init if setup not called yet
    if (!this.$rootScope) {
      this.initRequested = true;
      return;
    }

    // Run once regardless who calls us
    if (!this.backChannelServiceActive) {
      this.$rootScope.$on('receive-change', (evt: any, data: IBackChannelBooking[]) => this.docsUpdated(evt, data));
      if (Environment.IsLocal){
        console.log("BackChannel service active");
      }
      this.backChannelServiceActive = true;
    }
  }

  private docsUpdated(evt: any, data: IBackChannelBooking[]) {
    if (!data) return;

    GeneralSettingsService.get().then((settings) => {
      data.map(async (elem: IBackChannelBooking) => {
        if (Environment.IsLocal){
          console.log(elem);
        }

        const currentVenue = AdminService.getVenue();
        const isDateToday = DateUtilsService.isDateToday(new Date(elem.orgTime), currentVenue.timeZoneId);

        // The new doc does not have _revisions in elem. This property appears when the doc is updated.
        // Check it to distinguish whether the new doc is coming or an existing doc is updated, so it won't notify again.
        if (
          !elem._revisions &&
          elem.type &&
          elem.type === 'booking' &&
          (elem.method === BookingMethods.internet || elem.method === BookingMethods.abc) &&
          elem.status.name !== BookingStatusNames.Cancelled &&
          isDateToday &&
          ((settings.enableNewBookingNotification && elem.bookingType === BookingType.Booking) ||
          (settings.enableNewSBLBookingNotification && elem.bookingType === BookingType.StandbyList))
        ) {
          const time = moment(elem?.time).format('hh:mm A').toUpperCase();
          const fullName = `${elem.firstName} ${elem.lastName}`

          const text = elem?.bookingType === BookingType.StandbyList
            ? `New Standby list booking`
            : `New booking`;
          // Hotfix UI-1537 - to change the toast type of new booking
          const toastType = elem?.bookingType === BookingType.StandbyList ? ToastType.info : ToastType.success;
          const subText = elem?.bookingType === BookingType.StandbyList ? `${fullName}` : `${fullName}: ${time}`;
          if (this.timeOutId) {
            this.ToastActions.clearToast();
            clearTimeout(this.timeOutId);
          }

          this.timeOutId = setTimeout(() => this.ToastActions.showToast(text, toastType, subText), 200);
        }

        if (elem.type && elem.type == 'backchannel') {
          if (elem.alerts.length === 0) return;
          const [lastItem] = elem.alerts.slice(-1);

          if (Environment.IsLocal) {
            console.log("BackChannel: last item");
            console.log(lastItem);
          }
          this.$rootScope.$broadcast(WIDGET_CANCELLATION_SIGNAL);
          const theme = BookingStatusTypes.Cancelled;
          const foundBooking = lastItem?.bookingId
            ? await BookingLookupService.getById(lastItem.bookingId, new Date(lastItem.dateAndTime)).catch(() => null)
            : null
          // if the booking is not found => use default prefix
          const prefix = foundBooking?.bookingType === BookingType.StandbyList
            ? 'SBL Cancellation: '
            : 'Cancellation: '
          const text = prefix + lastItem.body;
          setTimeout(() => this.showToast(text, ToastType.error), 200);
        }
      });
    });
  }

  private showToast(body: string, toastType: ToastType): void {
    this.ToastActions.showToast(body, toastType);
  }
}

const instance = new BackChannelService();
export default instance as BackChannelService;
